import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../lib/redux/hooks'
import { CustomAccordion } from '../../../../ui/molecules/accordion'
import { ButtonComponent } from '../../../../ui/molecules/button/newButton'
import { Calendar } from '../../../../ui/molecules/calendar'
import { ProtocolSelectByObject } from '../../../../ui/molecules/ProtocolSelectByObj'
import { ProtocolSelectFromDate } from '../../../../ui/molecules/ProtocolSelectFromDate'
import { CustomRadio } from '../../../../ui/molecules/radioButton'
import { MadfarmStaticSelect } from '../../../../ui/molecules/select/newSelect/static'
import TextArea from '../../../../ui/molecules/textArea'
import { BusinessRegisterRequestMotivationOptions, BusinessRegisterTypologyRequestOptions } from '../../../../utils'
import { BusinessRegisterReleaseRegister } from '../dataService/dto'
import { DownloadRegisterSubmissionDocx, GetAllBusinessRegisters, resetGetAllBusinessRegistersStatus, setBusinessRegisterCreationNote, setBusinessRegisterCreationReleaseDate, setBusinessRegisterCreationReleaseProtocolId, setBusinessRegisterCreationReleaseRegister, setBusinessRegisterCreationRequestProtocolId, setBusinessRegisterCreationRequestReason, setBusinessRegisterCreationRequestType, setBusinessRegisterUpdateNote, setBusinessRegisterUpdateReleaseDate, setBusinessRegisterUpdateReleaseProtocolId, setBusinessRegisterUpdateRequestProtocolId, setBusinessRegisterUpdateRequestReason, setBusinessRegisterUpdateRequestType, setLatestAvailableDate } from '../slice'
import '../styles.scss'

export function AddRegistroForms() {
    const dispatch = useAppDispatch()
    const userState = useAppSelector(state => state.users)
    const registerState = useAppSelector(state => state.register)
    const sessionState = useAppSelector(state => state.session)
    const [closeFlag, setCloseFlag] = useState<string>('IDLE')
    const [expanded, setExpanded] = useState<string>('panel1')

    const handleToggleAccordion = (panel: string) => {
        setExpanded(prev => (prev === panel ? '' : panel))
    }

    useEffect(() => {
        dispatch(GetAllBusinessRegisters({ itemsPerPage: 1, page: 0, order: false, headQuarter: userState.findMeResponse.headQuarterInfo?.code }))
    }, [])

    useEffect(() => {
        if (registerState.getAllBusinessRegistersStatus === 'successfully' &&
            registerState.getAllBusinessRegistersResponse !== undefined
        ) {
            dispatch(resetGetAllBusinessRegistersStatus())
            if (registerState.getAllBusinessRegistersResponse.data.length > 0) {
                const latestDate: Date = new Date(registerState.getAllBusinessRegistersResponse.data[0].releaseDate)
                dispatch(setLatestAvailableDate(latestDate.setDate(latestDate.getDate() + 1)))
            }
            else {
                dispatch(setLatestAvailableDate(undefined))
            }

        }
    }, [registerState.getAllBusinessRegistersStatus])

    return (
        <div className="p-6 flex flex-col gap-6">
            <CustomAccordion
                id="panel1"
                title={<span className="text-uppercase text-white label-input">Dati richiesta RE002</span>}
                expanded={expanded === 'panel1'}
                onChange={() => handleToggleAccordion('panel1')}
                detailsClassName="flex flex-col gap-4"
            >
                <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
                    <MadfarmStaticSelect
                        label="Motivo richiesta"
                        noOptionsMessage="Nessun motivo disponibile"
                        value={!registerState.fromCreationToUpdate ? registerState.businessRegisterCreationRequest.requestReason : registerState.businessRegisterUpdateRequest.requestReason}
                        error={registerState.businessRegisterErrors.requestReason}
                        errorLabel='Motivazione mancante'
                        placeholder={'Seleziona motivazione...'}
                        options={BusinessRegisterRequestMotivationOptions}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            !registerState.fromCreationToUpdate ?
                            dispatch(setBusinessRegisterCreationRequestReason(newValue)) :
                            dispatch(setBusinessRegisterUpdateRequestReason(newValue))
                        }}
                    />
                    <ProtocolSelectByObject
                        title="Protocollo Richiesta [RRA]"
                        error={registerState.businessRegisterErrors.requestProtocolId}
                        errorLabel='Protocollo mancante'
                        type='entry'
                        objectId='88'
                        customerId={sessionState.selected.customerId!}
                        placeholder='Seleziona protocollo...'
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            !registerState.fromCreationToUpdate ?
                                dispatch(setBusinessRegisterCreationRequestProtocolId(newValue)) :
                                dispatch(setBusinessRegisterUpdateRequestProtocolId(newValue))
                        }}
                    />
                </div>

                <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
                    <MadfarmStaticSelect
                        label="Tipo di richiesta"
                        noOptionsMessage='Nessun risultato trovato'
                        error={registerState.businessRegisterErrors.requestType}
                        errorLabel='Tipologia mancante'
                        placeholder={'Seleziona tipologia...'}
                        options={BusinessRegisterTypologyRequestOptions}
                        value={!registerState.fromCreationToUpdate ? registerState.businessRegisterCreationRequest.requestType : registerState.businessRegisterUpdateRequest.requestType}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            !registerState.fromCreationToUpdate ?
                                dispatch(setBusinessRegisterCreationRequestType(newValue)) :
                                dispatch(setBusinessRegisterUpdateRequestType(newValue))
                        }}
                    />
                    <MadfarmStaticSelect
                        label="Notifica"
                        noOptionsMessage=''
                        placeholder={'Seleziona tipologia...'}
                        options={[{ value: '1', label: 'Tipo 1' }]}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                        }}
                    />
                </div>
            </CustomAccordion >

            <CustomAccordion
                id="panel2"
                title={<span className="text-uppercase text-white label-input">Rilascio registro</span>}
                expanded={expanded === 'panel2'}
                onChange={() => handleToggleAccordion('panel2')}
                detailsClassName="flex flex-col gap-4"
            >
                {
                    registerState.businessRegisterErrors.releaseMutualExclusion && (
                        <div className="rounded-lg border border-red-300 bg-red-50 px-4 py-3">
                            <span className="block text-sm font-semibold text-red-700">
                                Non è presente né Protocollo di rilascio né Data di Rilascio dal tecnico ispettore
                            </span>
                        </div>
                    )
                }

                <div className='pb-4 border-b border-neutral-200'>
                    <div className='flex flex-col gap-4'>
                        <div className='flex items-center'>
                            <div className='mt-5'>
                                <CustomRadio
                                    options={[{ label: '', value: 'CLOSE1' }]}
                                    selectedValue={closeFlag}
                                    onChange={(value) => {
                                        setCloseFlag(value)
                                        dispatch(setBusinessRegisterCreationReleaseRegister(BusinessRegisterReleaseRegister.PROTOCOLLO_RILASCIO))
                                        !registerState.fromCreationToUpdate ?
                                            dispatch(setBusinessRegisterCreationReleaseDate(undefined)) :
                                            dispatch(setBusinessRegisterUpdateReleaseDate(undefined))
                                    }}
                                    id={'close1'}
                                    name={'close1'}
                                />
                            </div>

                            <ProtocolSelectFromDate
                                title='Protocollo di rilascio'
                                type='departure'
                                disabled={closeFlag !== 'CLOSE1'}
                                fromDate={registerState.latestAvailableDate} // DA CAMBIARE CON ULTIMA DATA + 1 NEL LISTING
                                customerId={sessionState.selected.customerId!}
                                placeholder='Scegli protocollo di rilascio...'
                                onChange={(value) => !registerState.fromCreationToUpdate ?
                                    dispatch(setBusinessRegisterCreationReleaseProtocolId(value)) :
                                    dispatch(setBusinessRegisterUpdateReleaseProtocolId(value))}
                            />
                        </div>
                        <div className='flex items-center'>
                            <div className='mt-5'>
                                <CustomRadio
                                    options={[{ label: '', value: 'CLOSE2' }]}
                                    selectedValue={closeFlag}
                                    onChange={(value) => {
                                        setCloseFlag(value)
                                        dispatch(setBusinessRegisterCreationReleaseRegister(BusinessRegisterReleaseRegister.CONSEGNATI_DAL_TECNICO_ISPETTORE))
                                        !registerState.fromCreationToUpdate ?
                                            dispatch(setBusinessRegisterCreationReleaseProtocolId(undefined)) :
                                            dispatch(setBusinessRegisterUpdateReleaseProtocolId(undefined))
                                    }}
                                    id={'close2'}
                                    name={'close2'}
                                />
                            </div>
                            <Calendar
                                label="Consegnati dal tecnico ispettore nel corso della visita ispettiva / Data"
                                selected={!registerState.fromCreationToUpdate ?
                                    registerState.businessRegisterCreationRequest.releaseDate :
                                    registerState.businessRegisterUpdateRequest.releaseDate
                                }
                                onChange={(date) => !registerState.fromCreationToUpdate ?
                                    dispatch(setBusinessRegisterCreationReleaseDate(date)) :
                                    dispatch(setBusinessRegisterUpdateReleaseDate(date))}
                                minDate={registerState.latestAvailableDate}
                                disabled={closeFlag !== 'CLOSE2'}
                            />
                        </div>
                    </div>
                </div>
                <TextArea
                    onChangeText={(text) => !registerState.fromCreationToUpdate ?
                        dispatch(setBusinessRegisterCreationNote(text)) :
                        dispatch(setBusinessRegisterUpdateNote(text))}
                    label="Note"
                />
                {
                    registerState.fromCreationToUpdate &&
                    <div className='mt-2'>
                        {
                            registerState.businessRegisterCreationResponse &&
                            <div className="flex flex-wrap gap-3">
                                <ButtonComponent
                                    size="sm"
                                    iconPosition="off"
                                    variant="solid"
                                    label="Crea Word fase di avvio"
                                    color="blue"
                                    onClick={() => {
                                        if (registerState.businessRegisterCreationResponse) {
                                            dispatch(DownloadRegisterSubmissionDocx({ id: registerState.businessRegisterCreationResponse, infoType: 'LETTERA_CLIENTE' }))
                                        }
                                    }}
                                />
                                <ButtonComponent
                                    size="sm"
                                    iconPosition="off"
                                    variant="solid"
                                    label="Crea Word fase inserimento nuova attività"
                                    color="blue"
                                    onClick={() => {
                                        if (registerState.businessRegisterCreationResponse) {
                                            dispatch(DownloadRegisterSubmissionDocx({ id: registerState.businessRegisterCreationResponse, infoType: 'LETTERA_INSERIMENTO_ATTIVITA' }))
                                        }
                                    }}
                                />
                                <ButtonComponent
                                    size="sm"
                                    iconPosition="off"
                                    variant="solid"
                                    label="Crea Word Smarriti"
                                    color="blue"
                                    onClick={() => {
                                        if (registerState.businessRegisterCreationResponse) {
                                            dispatch(DownloadRegisterSubmissionDocx({ id: registerState.businessRegisterCreationResponse, infoType: 'LETTERA_REGISTRI_SMARRITI' }))
                                        }
                                    }}
                                />
                                <ButtonComponent
                                    size="sm"
                                    iconPosition="off"
                                    variant="solid"
                                    label="Crea Word Esauriti"
                                    color="blue"
                                    onClick={() => {
                                        if (registerState.businessRegisterCreationResponse) {
                                            dispatch(DownloadRegisterSubmissionDocx({ id: registerState.businessRegisterCreationResponse, infoType: 'LETTERA_REGISTRI_ESAURITI' }))
                                        }
                                    }}
                                />
                            </div>
                        }

                    </div>
                }
            </CustomAccordion>
        </div >
    )
}